<template>
    <div id="app" class="container p-3">
        <div v-if="!generated_link">
            <validation-observer ref="observer" v-slot="{ passes }">
                <form @submit.stop.prevent="passes(generateLink)">
                    <validation-provider name="phone number" rules="landphone|required" v-slot="{ errors }">
                        <label for="phone" class="mt-3 mb-2">☎️ Type your WhatsApp phone number</label>
                        <b-form-input id="phone" v-model="phone_number" autocomplete="tel" placeholder="Your phone number incl. land code"></b-form-input>
                        <span class="validation">{{ errors[0] }}</span>
                    </validation-provider>

                    <validation-provider name="preset message" rules="" v-slot="{ errors }">
                        <label for="message" class="mt-3 mb-2">💬 Custom message</label>
                        <b-form-textarea id="message" v-model="preset_message" placeholder="Add a custom message that your customer will send you."></b-form-textarea>
                        <span class="validation">{{ errors[0] }}</span>
                    </validation-provider>

                    <button type="submit" class="btn btn-success btn-lg mt-3 mb-2 btn-block">Generate link</button>
                </form>
            </validation-observer>
        </div>
        <div v-else>
            <p class="font-weight-bold text-center">Your WhatsApp link is ready 🎉</p>

            <div v-if="message" class="alert-success alert">{{message}}</div>
            <button @click="copyLink" class="btn btn-success btn-lg mt-2 btn-block">Copy</button>

            <a :href="generated_link" target="_blank" class="btn btn-outline-success btn-lg mt-2 btn-block">Test</a>

            <button @click="resetGenerator" class="btn btn-link  mt-2 btn-block">Again</button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'app',
    data: () => ({
        phone_number: null,
        preset_message: null,
        generated_link: null,
        message: null,
    }),
    methods: {

        /**
         * Update user
         */
        generateLink: function () {
            //https://api.whatsapp.com/send/?phone=<reference:digits>&text=<text:urlencode>

            // clean phone
            let phone = this.phone_number.replace(/\D/g, '');

            // clean message
            let preset = ''
            if(this.preset_message) {
                preset = encodeURIComponent(this.preset_message)
            }

            this.generated_link = 'https://api.whatsapp.com/send/?phone=' + phone + '&text=' + preset
        },
        resetGenerator: function () {
            this.generated_link = null
            this.message = null
        },
        /**
         * Copy embed code
         */
        copyLink: function () {
            let main = this
            this.$copyText(this.generated_link).then(function (e) {
                main.message = 'Copied'
            }, function (e) {
                main.message = 'Can not copy'
            })
        },
    },
}
</script>